export default __webpack_public_path__ + "static/RiseupLogoWhite-3471cfb1ee2bd30ec9792f9e636de035.png";